import N from "numeral";
import moment from "moment";
import { unlessNull } from "../";

const EASTERN_TIME_ZONE = "America/New_York";
const easternDateFormatter = new Intl.DateTimeFormat("en-US", {
  timeZone: EASTERN_TIME_ZONE,
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
});
const easternDateTimeFormatter = new Intl.DateTimeFormat("en-US", {
  timeZone: EASTERN_TIME_ZONE,
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
});

export const currencyFormatter = (format = "$0,0.00") =>
  unlessNull((val) => N(val).format(format));

export const formatCurrencyEx = (val) => {
  const v = `${val}`;
  if (!v) return "";
  else if (v.slice(-1) === ".") return N(v).format("$0,0") + ".";
  else if (v.slice(-2, -1) === ".") return N(v).format("$0,0[.]0");
  else return v !== "$" ? N(v).format("$0,0[.]00") : "";
};

const getPhoneParts = (phoneNumber) =>
  `${phoneNumber}`.replace(/\D/g, "").match(/^(\d{3})(\d{3})(\d{4})$/);

export const formatPhone = (phoneNumberString) => {
  const phoneParts = getPhoneParts(phoneNumberString);
  return phoneParts
    ? `(${phoneParts[1]}) ${phoneParts[2]}-${phoneParts[3]}`
    : null;
};

export const formatPhoneHref = (phoneNumberString) => {
  const phoneParts = getPhoneParts(phoneNumberString);
  return phoneParts
    ? `${phoneParts[1]}-${phoneParts[2]}-${phoneParts[3]}`
    : null;
};

export const formatUnixDate = (date) =>
  moment.unix(date).utc().format("MM/DD/YYYY");

export const formatISODate = (date) => moment(date).format("MM/DD/YYYY");

export const formatDate = (date) => {
  if (date == null) return null;
  if (typeof date === "number")
    return moment.unix(date).utc().format("MM/DD/YYYY");
  return moment(date).format("MM/DD/YYYY");
};

export const formatDateTime = (date) => {
  if (date == null) return null;
  const m = typeof date === "number" ? moment.unix(date) : moment(date);
  const tzAbbr =
    new Intl.DateTimeFormat("en-US", { timeZoneName: "short" })
      .formatToParts(m.toDate())
      .find((part) => part.type === "timeZoneName")?.value || "";
  return `${m.format("MM/DD/YYYY h:mm A")} ${tzAbbr}`;
};

export const formatAsEastern = (date, { includeTime = false } = {}) => {
  if (date == null) return null;
  if (Number.isNaN(date.getTime())) return null;
  const formatter = includeTime
    ? easternDateTimeFormatter
    : easternDateFormatter;
  return `${formatter.format(date).replace(",", "")}`;
};
